export function updatePreviewItem(itemId) {
  	return (dispatch) => dispatch({ type: 'UPDATE_PREVIEW_ITEM',itemId})
	    
}

